import React from 'react'
import { getSwitchExchangeToken } from '../../appswitch/AppSwitchSaga';
import { useDispatch } from 'react-redux';
import PageInfoCard from '../pageinfocard/PageInfoCard';
import { PARAMETER_FOR_APP_SWITCH_REDIRECT_URL } from '../../constants/constants';

const ConfirmRedirection = () => {
    const dispatch = useDispatch();

    return (
        <PageInfoCard
            cardTitle="Classic view contains the full set of integrations and import features. Click below to redirect to the classic view."
            confirmationButtonProps={{
                onConfirmationCb: () => { dispatch(getSwitchExchangeToken({source: PARAMETER_FOR_APP_SWITCH_REDIRECT_URL.IMPORT})) },
                confirmationButtonText: "Go to Classic App",
            }}
        />
    )
}

export default ConfirmRedirection